import React from 'react'
import { Switch, Route } from 'react-router-dom'
import screens from 'screens'
import * as routePaths from 'constants/routePaths'


const Routes = () => (
    <Switch>
        <Route exact path={routePaths.LIST} component={screens.List} />
        <Route path={routePaths.LOGIN} component={screens.Login} />
        <Route path={routePaths.EMAIL} component={screens.Email} />

        <Route component={screens.NotFound} />
    </Switch>
)

export default Routes
